module.exports = __webpack_public_path__ + "img/form-settings-expand.1bbdaa4a.svg";